const drawerWidth = 200;

export const useStyles = (theme) => ({
  appBar: {
    backgroundColor: "#0a1f3a",
    [theme.breakpoints.up(960)]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(960)]: {
      display: "none",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(960)]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(960)]: {
      display: "flex",
    },
  },
});
